module.exports = __webpack_public_path__ + "static/media/ministryofcoin_logo_dark.3b1b0139.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/ministryofcoin_logo_dark.svg
// module id = 901
// module chunks = 0